import i18n from 'i18next';

export const POSITION_COLUMN_PHRASE_KEY =
  'components.setup_note_modal.position_column_phrase' as const;

let cachedVariants: readonly string[] | null = null;

function supportedTranslationLocales(): string[] {
  const sl = i18n.options.supportedLngs;
  if (Array.isArray(sl)) {
    return sl.filter(
      (lng): lng is string => typeof lng === 'string' && lng !== 'cimode'
    );
  }
  return ['fr', 'en'];
}

/**
 * Distinct phrase strings for each configured locale (notes may contain text pasted
 * from any language). Resolved once and cached — i18n lookups are not repeated.
 */
export function getPositionColumnPhraseVariants(): readonly string[] {
  if (cachedVariants !== null) return cachedVariants;
  const locales = supportedTranslationLocales();
  const phrases = locales.map((lng) =>
    i18n.getFixedT(lng)(POSITION_COLUMN_PHRASE_KEY)
  );
  cachedVariants = Object.freeze([...new Set(phrases)]);
  return cachedVariants;
}

export function noteContainsAnyPositionColumnPhrase(note: string): boolean {
  return getPositionColumnPhraseVariants().some((p) => note.includes(p));
}

export function ensureDealSetupPositionPhrase(
  note: string,
  useYes: boolean
): string {
  if (!useYes) return note;
  const phrase = i18n.t(POSITION_COLUMN_PHRASE_KEY);
  if (getPositionColumnPhraseVariants().some((p) => note.includes(p)))
    return note;
  const trimmed = note.trim();
  return trimmed === '' ? phrase : `${trimmed}\n${phrase}`;
}

export function stripDealSetupPositionPhrase(note: string): string {
  let result = note;
  for (const p of getPositionColumnPhraseVariants()) {
    result = result.split(p).join('');
  }
  return result.replace(/\n{3,}/g, '\n\n').trim();
}

/** @internal Vitest only — reset module cache when i18n resources are mocked */
export function clearPositionColumnPhraseVariantsCache(): void {
  cachedVariants = null;
}
